import { Translate } from 'lang'
import {
  mdiBarn,
  mdiBugOutline,
  mdiOfficeBuildingCog,
  mdiViewDashboard,
  mdiWrench,
  mdiFaceAgent,
} from '@mdi/js'
import { REPORT_BUGS_LINKS } from 'views/App/B2B/ReportBugs/routes'

const PREFIX = '/admin'

export const Root = ({ permissions }) => {
  return [
    {
      key: 'dashboard',
      title: Translate({ messageKey: 'dashboard' }),
      path: '/',
      icon: mdiViewDashboard,
      enabled: permissions.systemReader,
    },
    {
      key: 'farms',
      title: 'Farm',
      icon: mdiBarn,
      submenu: [
        {
          key: 'acconts-farm',
          title: Translate({
            messageKey: 'account',
            howMany: 'many',
            items: {
              item: 'Farm',
            },
          }),
          path: `${PREFIX}/farm/user`,
          enabled: permissions.gerenciamentoRootReader,
        },
        {
          key: 'farm-users',
          title: Translate({
            messageKey: 'user',
            howMany: 'many',
            items: {
              item: 'Farm',
            },
          }),
          path: `${PREFIX}/farm/user-farm`,
          enabled: permissions.gerenciamentoRootReader,
        },
        {
          key: 'roles-farm',
          title: Translate({
            messageKey: 'role',
            howMany: 'many',
            items: {
              item: 'Farm',
            },
          }),
          path: `${PREFIX}/farm/roles`,
          enabled: permissions.gerenciamentoRootReader,
        },
        {
          key: 'planos-farm',
          title: Translate({
            messageKey: 'plan',
            howMany: 'many',
            items: {
              item: 'Farm',
            },
          }),
          path: `${PREFIX}/farm/plans`,
          enabled: permissions.gerenciamentoRootReader,
        },
      ],
    },
    {
      key: 'root',
      title: Translate({ messageKey: 'root' }),
      icon: mdiOfficeBuildingCog,
      submenu: [
        {
          key: 'root_users',
          title: Translate({
            messageKey: 'user',
            howMany: 'many',
            items: {
              item: Translate({ messageKey: 'root' }),
            },
          }),
          path: `${PREFIX}/root/users`,
          enabled: permissions.gestaoDeContasFarmReader,
        },
        {
          key: 'roles',
          title: Translate({
            messageKey: 'role',
            howMany: 'many',
            items: {
              item: Translate({ messageKey: 'root' }),
            },
          }),
          path: `${PREFIX}/root/roles`,
          enabled: permissions.gestaoDeContasFarmReader,
        },
        {
          key: 'functionalities',
          title: Translate({ messageKey: 'functionality', howMany: 'many' }),
          path: `${PREFIX}/root/functionalities`,
          enabled: permissions.gestaoDeContasFarmReader,
        },
        {
          key: 'system_connections',
          title: 'Conexões',
          path: `${PREFIX}/root/connections`,
          enabled: permissions.systemReader,
        },
      ],
    },
    {
      key: 'hardware',
      title: 'Hardware',
      icon: mdiWrench,
      submenu: [
        {
          key: 'hardware_devices',
          title: Translate({ messageKey: 'devices', howMany: 'many' }),
          path: `${PREFIX}/hardware/devices`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'hardware_tags',
          title: Translate({ messageKey: 'tag', howMany: 'many' }),
          path: `${PREFIX}/hardware/tags`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'movement_tag',
          title: Translate({ messageKey: 'movement_tags', howMany: 'many' }),
          path: `${PREFIX}/hardware/movement-tags`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'hardware_identification_tags',
          title: Translate({ messageKey: 'identification_tag', howMany: 'many' }),
          path: `${PREFIX}/hardware/identification-tags`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'hardware_import_tags',
          title: Translate({ messageKey: 'import_tag', howMany: 'many' }),
          path: `${PREFIX}/hardware/import-tags`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'hardware_production_tags',
          title: Translate({ messageKey: 'production_tag', howMany: 'many' }),
          path: `${PREFIX}/hardware/production-tags`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'hardware_gateway',
          title: Translate({ messageKey: 'gateway', howMany: 'many' }),
          path: `${PREFIX}/hardware/gateways`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        // {
        //   key: 'hardware_router_mobile',
        //   title: Translate({ messageKey: 'router_mobile', howMany: 'many' }),
        //   path: `${PREFIX}/hardware/router-mobile`,
        //   enabled: permissions.gestaoDeHardwareReader,
        // },
        {
          key: 'hardware_router_fixed',
          title: Translate({ messageKey: 'router_fixed', howMany: 'many' }),
          path: `${PREFIX}/hardware/router-fixed`,
          enabled: permissions.gestaoDeHardwareReader,
        },
      ],
    },
    {
      key: 'customer',
      title: Translate({ messageKey: 'customer_service', howMany: 'many' }),
      icon: mdiFaceAgent,
      submenu: [
        {
          key: 'help_desk',
          title: Translate({ messageKey: 'help_desk', howMany: 'many' }),
          path: `${PREFIX}/customer-service/help-desk`,
          enabled: permissions.gestaoDeHardwareReader,
        },
        {
          key: 'history_logs',
          title: Translate({ messageKey: 'history_log', howMany: 'many' }),
          path: `${PREFIX}/customer-service/history-logs`,
          enabled: permissions.gestaoDeHardwareReader,
        },
      ],
    },
    {
      key: 'report_bugs',
      title: 'Reportar',
      icon: mdiBugOutline,
      submenu: REPORT_BUGS_LINKS.map(item => ({
        ...item,
        enabled: permissions.gestaoDeHardwareReader,
      })),
    },
  ]
}
